import { useUBL } from '@common/log-manager';
import { useReviewListConfig } from '@domains/review-list-common';

export function useSummaryCardUBL() {
  const sendUbl = useUBL();
  const { catalog_product_id } = useReviewListConfig();

  return {
    impressionReviewSummary: (option: { review_id: string; object_idex: number }) => {
      sendUbl({
        category: 'impression',
        navigation: 'product_detail',
        object_section: 'review_summary',
        object_type: 'review',
        object_id: option.review_id,
        object_idx: option.object_idex,
        data: {
          catalog_product_id,
          type: 'photo',
        },
      });
    },
    clickAllButton: () => {
      sendUbl({
        category: 'click',
        navigation: 'product_detail',
        object_section: 'review_summary',
        object_id: 'review_all',
        object_type: 'button',
        data: {
          catalog_product_id,
        },
      });
    },
    clickPhotoThumbnail: (option: { review_id: string; object_idex: number }) => {
      sendUbl({
        category: 'click',
        navigation: 'product_detail',
        object_section: 'review_summary',
        object_type: 'review',
        object_id: option.review_id,
        object_idx: option.object_idex,
        data: {
          catalog_product_id,
          type: 'photo',
        },
      });
    },
  };
}
